<template>
  <div>
    <div class="container">
      <section id="filter">
        <div class="row mt-2">
          <div class="col-6">
            <input
              placeholder="Mulai Tgl. Registrasi"
              class="form-control m-2"
              :type="typeRegisStart"
              @focus="typeRegisStart = 'date'"
              @blur="
                filter.tglOnlineStart == '' ? (typeRegisStart = 'text') : (typeRegisStart = 'date')
              "
              id="date"
              v-model="filter.tglOnlineStart"
            />
          </div>
          <div class="col-6">
            <input
              placeholder="Akhir Tgl. Registrasi"
              class="form-control m-2"
              :type="typeRegisEnd"
              @focus="typeRegisEnd = 'date'"
              @blur="filter.tglOnlineEnd == '' ? (typeRegisEnd = 'text') : (typeRegisEnd = 'date')"
              id="date"
              v-model="filter.tglOnlineEnd"
            />
          </div>
          <div class="col-4">
            <input
              placeholder="Tgl. Upload"
              class="form-control m-2"
              :type="typeTglUpload"
              @focus="typeTglUpload = 'date'"
              @blur="filter.tglUpload == '' ? (typeTglUpload = 'text') : (typeTglUpload = 'date')"
              id="date"
              v-model="filter.tglUpload"
            />
          </div>
          <div class="col-4">
            <select
              class="form-select m-2"
              v-model="filter.client"
              :class="filter.client ? '' : 'text-secondary'"
            >
              <option value="" selected>
                {{ filter.client ? "none" : "Client" }}
              </option>
              <option
                v-for="client in dataClient.content"
                :key="client.id"
                class="text-dark"
                :value="client.id"
              >
                {{ client.name }}
              </option>
            </select>
          </div>
          <div class="col-4">
            <input
              placeholder="Batch"
              class="form-control m-2"
              type="text"
              list="batch"
              v-model="filter.batch"
              @keyup="getDataBatch($event)"
            />
            <datalist id="batch">
              <option v-for="(batch, index) in dataBatch" :key="index">
                {{ batch.batch }}
              </option>
            </datalist>
          </div>
          <div class="col-4">
            <input
              placeholder="MTS"
              class="form-control m-2"
              type="text"
              list="mts"
              v-model="filter.mts"
              @keyup="getDataMts($event)"
            />
            <datalist id="mts">
              <option v-for="(mts, index) in dataMts" :key="index">
                {{ mts.mts }}
              </option>
            </datalist>
          </div>
          <div class="col-4">
            <input
              placeholder="Station"
              class="form-control m-2"
              type="text"
              list="station"
              v-model="filter.station"
              @keyup="getDataStation($event)"
            />
            <datalist id="station">
              <option v-for="(station, index) in dataStation" :key="index">
                {{ station.station }}
              </option>
            </datalist>
          </div>
          <div class="col-4">
            <button
              @click="getDataPerangkat(0)"
              class="btn btn-success rounded-pill shadow text-white mx-2"
            >
              <i class="fa fa-search"></i>
            </button>
            <button @click="refresh()" class="btn btn-success rounded-pill shadow text-white mx-2">
              <i class="fa fa-refresh"></i>
            </button>
          </div>
        </div>
      </section>
      <div class="row mt-3">
        <div class="col-12">
          <div class="card">
            <div class="card-header pb-0 mb-3">
              <div class="row">
                <div class="col-6">
                  <h6>PERANGKAT</h6>
                </div>
                <div class="col-6">
                  <div class="btn-group float-end" role="group" aria-label="Basic example">
                    <button
                      type="button"
                      class="btn btn-outline-secondary btn-sm py-2 px-3"
                      @click="toDuplikasi()"
                    >
                      <i class="fa fa-files-o text-primary"></i> Duplikasi
                      <span class="bg-danger text-white p-1 rounded-circle notif-text">{{
                        jumlahDuplikat
                      }}</span>
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-secondary btn-sm py-2 px-3"
                      @click="toRiwayat()"
                    >
                      <i class="fa fa-history text-success"></i> Riwayat
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-secondary btn-sm py-2 px-3"
                      data-bs-toggle="modal"
                      :data-bs-target="`#${ModalDownload}`"
                    >
                      <i class="fa fa-download text-danger"></i> Download
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-secondary btn-sm py-2 px-3"
                      data-bs-toggle="modal"
                      :data-bs-target="`#${Modal1}`"
                      @click="getSateliteList()"
                    >
                      <i class="fa fa-upload text-primary"></i> Upload
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body px-0 pt-0 pb-2">
              <table-imani-prima
                :rows="rows"
                :data-length="dataLength"
                :page-length="pageLength"
                :current-page="currentpage"
                :offset="pageOffset"
                :size="eachPageSize"
                @get-data="getDataPerangkat(0)"
              >
                <template #button>
                  <paginate
                    v-model="pagination"
                    :page-count="pageLength"
                    :page-range="5"
                    :margin-pages="1"
                    :click-handler="movePage"
                    :prev-text="'<'"
                    :next-text="'>'"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                    :first-last-button="true"
                    first-button-text="<<"
                    last-button-text=">>"
                  >
                  </paginate>
                </template>
              </table-imani-prima>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <Modal
      :modalName="ModalDownload"
      modalTitle="Download Perangkat"
      rightBtnLabel="Batal"
      leftBtnLabel="Download"
      @leftBtnFun="downloadPerangkat()"
    >
      <template #body>
        <div class="my-2">
          <label for="tujuan">Tujuan</label>
          <select
            class="form-select"
            v-model="filterDownload.tujuan"
            :class="filterDownload.tujuan ? '' : 'text-secondary'"
            id="tujuan"
          >
            <option class="text-dark" value="Finance">Finance</option>
            <option class="text-dark" value="Postel">Postel</option>
          </select>
        </div>
        <div class="my-2">
          <label for="tanggal">Tanggal Upload</label>
          <input type="date" class="form-control" v-model="filterDownload.tglUpload" />
        </div>
        <div class="my-2">
          <label for="batch">Batch</label>
          <input
            placeholder="Batch"
            class="form-control"
            type="text"
            list="batch2"
            v-model="filterDownload.batch"
            @keyup="getDataBatchDownload($event)"
          />
          <datalist id="batch2">
            <option v-for="(batch, index) in dataBatchDownload" :key="index">
              {{ batch.batch }}
            </option>
          </datalist>
        </div>
        <div class="my-2">
          <label for="total">Total Data Per File</label>
          <select
            class="form-select"
            v-model="filterDownload.totalDataPerPage"
            :class="filterDownload.totalDataPerPage ? '' : 'text-secondary'"
            id="total"
          >
            <option class="text-dark" value="25">25</option>
            <option class="text-dark" value="50">50</option>
            <option class="text-dark" value="100">100</option>
            <option class="text-dark" value="200">200</option>
            <option class="text-dark" value="250">250</option>
          </select>
        </div>
      </template>
    </Modal>
    <modal
      :modalName="Modal1"
      modalTitle="Upload Perangkat"
      :isFooter="false"
    >
      <template #body>
        <div>
          <button id="closeModal1Btn" data-bs-dismiss="modal" style="display: none;"></button>

          <label for="inputEmailDate">Tanggal Email <span class="text-danger">*</span></label>
          <input
            placeholder="Tgl. Email"
            class="form-control m-2"
            :type="typeTglEmail"
            @focus="typeTglEmail = 'date'"
            @blur="uploadExcel.emailDate == '' ? (typeTglEmail = 'text') : (typeTglEmail = 'date')"
            id="date"
            v-model="uploadExcel.emailDate"
          />
          <small v-if="errors.emailDate" class="text-danger text-xs ms-2 d-block mb-2">{{ errors.emailDate }}</small>

          <label for="inputOnlineDate">Tanggal Online <span class="text-danger">*</span></label>
          <input
            placeholder="Tgl. Online"
            class="form-control m-2"
            :type="typeTglOnline"
            @focus="(typeTglOnline='date')"
            @blur="(uploadExcel.onlineDate == '' ? typeTglOnline='text' : typeTglOnline='date')"
            id="date"
            v-model="uploadExcel.onlineDate"
          />
          <small v-if="errors.onlineDate" class="text-danger text-xs ms-2 d-block mb-2">{{ errors.onlineDate }}</small>

          <label for="pelangganOption">Pelanggan</label>
          <select class="form-select m-2" v-model="uploadExcel.client">
            <option
              v-for="client in dataClient.content"
              :key="client.id"
              class="text-dark"
              :value="client.id"
            >
              {{ client.name }}
            </option>
          </select>
          <small v-if="errors.client" class="text-danger text-xs ms-2 d-block mb-2">{{ errors.client }}</small>
        
          <label for="sateliteOption" class="mt-2">Satelite</label>
          <select class="form-select m-2" v-model="uploadExcel.satelite">
            <option
              v-for="(sat, i) in dataSatelite"
              :key="sat.id"
              class="text-dark"
              :value="sat.id"
              :selected="i == 0"
            >
              {{ sat.name }}
            </option>
          </select>
          <small v-if="errors.satelite" class="text-danger text-xs ms-2 d-block mb-2">{{ errors.satelite }}</small>

          <label for="fileUpload" class="form-label mb-0 mt-3">Pilih File</label> <br />
          <input
            type="file"
            id="fileUploadButton"
            :accept="acceptedFiles"
            @change="uploadFile($event)"
            hidden
          />
          <label id="fileUploadButtonLabel" for="fileUploadButton" class="btn btn-secondary mt-2 ms-2 mb-0"
            >Choose File</label
          >
          <span class="ms-2">{{ uploadExcel.file.name }}</span>
          <small v-if="errors.file" class="text-danger text-xs ms-2 d-block mb-2">{{ errors.file }}</small>

          <div class="d-flex justify-content-end mt-4">
            <button type="button" class="btn btn-outline-success me-2" data-bs-dismiss="modal">
              Batal
            </button>
            <button
              type="button"
              class="btn btn-success"
              @click="submit()"
              :disabled="isSubmitDisabled"
            >
              Submit
            </button>
          </div>
        </div>
      </template>
    </modal>
    <Alert :alertName="alert1" :alertType="alertType">
      <template #body>
        <div v-if="loadingImport">
          <h2 class="mt-2">Loading Import</h2>
        </div>
        <div v-if="alertType === 'success'">
          <h2 class="mt-2">Data Berhasil di Import</h2>
          <p>Silahkan tinjau hasil Upload</p>
          <button
            data-bs-dismiss="modal"
            data-bs-toggle="modal"
            :data-bs-target="`#${Modal2}`"
            class="btn btn-primary"
          >
            Lanjut
          </button>
        </div>
        <div v-if="alertType === 'error'">
          <h2 class="mt-2">{{ messageRes.code }} Error:</h2>
          <p>{{ messageRes.text }}</p>
          <button data-bs-dismiss="modal" data-bs-toggle="modal" class="btn btn-primary">
            done
          </button>
        </div>
        <div v-if="alertType === 'loading'">
          <p>Loading</p>
        </div>
        <div v-if="alertType === 'successDownload'">
          <svg
            width="94"
            height="94"
            viewBox="0 0 94 94"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M91.1664 42.9362V46.9996C91.1609 56.5238 88.0769 65.791 82.3742 73.4193C76.6716 81.0475 68.6558 86.628 59.5225 89.3285C50.3892 92.0289 40.6276 91.7046 31.6936 88.404C22.7596 85.1033 15.1319 79.0032 9.94808 71.0133C4.76427 63.0234 2.30209 53.5718 2.92875 44.0683C3.55541 34.5647 7.23734 25.5183 13.4254 18.2783C19.6135 11.0383 27.9761 5.9925 37.2662 3.89354C46.5562 1.79458 56.2759 2.75489 64.9755 6.63123"
              stroke="#54AD1D"
              stroke-width="5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M91.1667 11.667L47 55.8778L33.75 42.6278"
              stroke="#54AD1D"
              stroke-width="5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <h2>Sukses Download</h2>
          <button data-bs-dismiss="modal" data-bs-toggle="modal" class="btn btn-primary">
            done
          </button>
        </div>
      </template>
    </Alert>
    <modal
      :modalName="Modal2"
      modalSize="modal-lg"
      modalTitle="Hasil Upload"
      rightBtnLabel="Tutup"
      leftBtnLabel="Lanjutkan"
      @leftBtnFun="done()"
    >
      <template #body>
        <div class="row">
          <div class="col-8">
            <ul>
              <li>
                <p class="text-success">
                  <strong>{{ addData || 0 }} data berhasil ditambahkan</strong>
                </p>
              </li>
              <li>
                <p class="text-danger">
                  <strong>{{ duplicateData || 0 }} data terdeteksi duplikat</strong>
                </p>
              </li>
            </ul>
          </div>
          <div class="col-4">
            <div class="float-end pe-5 text-center">
              <span>Total</span>
              <h2>{{ addData + duplicateData }}</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 p-4 pb-0">
            <p class="text-xs">
              Klik
              <span class="text-danger"><b>Tombol Lanjutkan</b></span> untuk ke halaman
              <b>DUPLIKASI</b>, atau klik tombol <b>TUTUP</b> untuk kembali ke halaman
              <b>PERANGKAT</b>. Halaman <b>DUPLIKASI</b> dapat diakses melalui halaman
              <b>PERANGKAT</b>
            </p>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script setup>
//Import
import Modal from "@/components/ModalComponent.vue";
import Alert from "@/components/AlertComponent.vue";
import TableImaniPrima from "../../components/perangkat/TableImaniPrima.vue";
import Paginate from "vuejs-paginate-next";
import { useRouter } from "vue-router";
import { computed, onMounted, ref, onUnmounted, watch } from "vue";
import { useStore } from "vuex";
import { ApiService } from "@/axios/apiService";

//Data
const apiService = new ApiService();
const router = useRouter();
const store = useStore();
const pagination = computed(() => currentpage.value + 1);
const duplicateData = ref();
const addData = ref();
const alertType = ref("");
const acceptedFiles = ref([".xml", ".xls", ".xlsx"]);
const dataClient = ref([]);
const dataMts = ref([]);
const dataBatch = ref([]);
const dataStation = ref([]);
const filter = ref({
  tglUpload: "",
  client: "",
  mts: "",
  station: "",
  batch: "",
  tglOnlineStart: "",
  tglOnlineEnd: "",
});
const Modal1 = "modal1";
const Modal2 = "modal2";
const alert1 = "alert1";
const loadingImport = ref(false);
const currentpage = ref(0);
const rows = ref([]);
let pageOffset = ref(0);
let eachPageSize = ref(0);
const pageLength = ref(0);
const dataLength = ref(0);
const uploadExcel = ref({
  emailDate: "",
  onlineDate: "",
  client: "",
  file: "",
  satelite: "1",
});
const errors = ref({
  emailDate: "",
  onlineDate: "",
  client: "",
  satelite: "",
  file: "",
});
const isSubmitDisabled = computed(() => {
  return Object.values(errors.value).some((msg) => msg !== "");
});

watch(uploadExcel, (newForm) => {
  for (const key in errors.value) {
    if (newForm[key]) {
      errors.value[key] = "";
    }
  }
}, { deep: true });
const ModalDownload = "ModalDownload";
const filterDownload = ref({
  tujuan: "Postel",
  tglUpload: "",
  batch: "",
  totalDataPerPage: "",
  client: "",
});
const jumlahDuplikat = ref(0);
const dataSatelite = ref([]);
const typeRegisStart = ref("text");
const typeRegisEnd = ref("text");
const typeTglUpload = ref("text");
const typeTglEmail = ref("text");
const typeTglOnline = ref("text");

//Method
const downloadPerangkat = async () => {
  const data = filterDownload.value;
  try {
    if (data.batch === "") throw new Error("Batch Tidak Boleh Kosong");
    if (data.totalDataPerPage === "") throw new Error("Total Data Per Page Tidak Boleh Kosong");

    alertType.value = "loading";
    let link = document.createElement("button");
    link.type = "button";
    link.setAttribute("data-bs-toggle", "modal");
    link.setAttribute("data-bs-target", `#${alert1}`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    const params = `&tglUpload=${data.tglUpload}&batch=${data.batch}`;
    const response = await apiService.downloadExcelPerangkat(data.totalDataPerPage, params);
    const href = URL.createObjectURL(response.data);
    link = document.createElement("a");
    link.href = href;
    link.setAttribute("download", "PERANGKAT_" + data.batch + "_POSTEL.zip");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
    alertType.value = "successDownload";
    filterDownload.value = {
      tujuan: "",
      tglUpload: "",
      batch: "",
      totalDataPerPage: "",
      client: "",
    };
  } catch (error) {
    console.log(error);
    store.dispatch("swalError", { code: 400, text: error.message });
  }
};

const refresh = async () => {
  filter.value = {
    tglUpload: "",
    client: "",
    mts: "",
    station: "",
    batch: "",
    tglOnlineStart: "",
    tglOnlineEnd: "",
  };
  typeRegisStart.value = "text";
  typeRegisEnd.value = "text";
  typeTglUpload.value = "text";
  await getDataPerangkat(0);
};

const getDataPerangkat = async (pageNumber) => {
  try {
    store.state.isLoading = true;
    currentpage.value = pageNumber;
    const filterPayload = filter.value;
    let params = "";
    if (filterPayload.tglUpload !== "" && filterPayload.tglUpload !== null) {
      params += `&tglUpload=${filterPayload.tglUpload}`;
    }
    if (filterPayload.client !== "" && filterPayload.client !== null) {
      params += `&client=${filterPayload.client}`;
    }
    if (filterPayload.mts !== "" && filterPayload.mts !== null) {
      params += `&mts=${filterPayload.mts}`;
    }
    if (filterPayload.station !== "" && filterPayload.station !== null) {
      params += `&station=${filterPayload.station}`;
    }
    if (filterPayload.batch !== "" && filterPayload.batch !== null) {
      params += `&batch=${filterPayload.batch}`;
    }
    if (filterPayload.tglOnlineStart !== "" && filterPayload.tglOnlineStart !== null) {
      params += `&tglOnlineStart=${filterPayload.tglOnlineStart}`;
    }
    if (filterPayload.tglOnlineEnd !== "" && filterPayload.tglOnlineEnd !== null) {
      params += `&tglOnlineEnd=${filterPayload.tglOnlineEnd}`;
    }
    filterMove = params;
    const res = await apiService.getAllPerangkat(pageNumber, 10, params);
    rows.value = res.data.content;
    pageLength.value = res.data.totalPages;
    dataLength.value = res.data.totalElements;
    pageOffset.value = 10 * currentpage.value;
    eachPageSize.value = res.data.size;
    store.state.isLoading = false;
  } catch (error) {
    console.log(error);
    store.state.isLoading = false;
  }
};

let filterMove = "";
const movePage = async (pageNumber) => {
  store.state.isLoading = true;
  currentpage.value = pageNumber - 1;
  const res = await apiService.getAllPerangkat(currentpage.value, 10, filterMove);
  rows.value = res.data.content;
  pageLength.value = res.data.totalPages;
  dataLength.value = res.data.totalElements;
  pageOffset.value = 10 * currentpage.value;
  eachPageSize.value = res.data.size;
  store.state.isLoading = false;
};

const getDataPelanggan = async () => {
  const res = await apiService.getPelanggan(10, 0);
  dataClient.value = res.data;
};

const getSateliteList = async () => {
  errors.value = {
    emailDate: "",
    onlineDate: "",
    client: "",
    satelite: "",
    file: "",
  };
  const res = await apiService.getSatelite();
  dataSatelite.value = res.data;
};

onMounted(async () => {
  const res = await apiService.getDuplikasi(0, "", "");
  jumlahDuplikat.value = res.data.totalElements;
  await getDataPelanggan();
  if (store.state.selectedBatchUpload) {
    filter.value.batch = store.state.selectedBatchUpload;
    await getDataPerangkat(currentpage.value);
  } else {
    await getDataPerangkat(currentpage.value);
  }
});

//Perangkat-Upload
const messageRes = ref({
  code: "",
  text: "",
});

const uploadFile = (event) => {
  if (event.target.files.length > 0) {
    const file = event.target.files.item(0);
    uploadExcel.value.file = file;
  }
};

const validate = () => {
  let isValid = true;
  errors.value = {
    emailDate: "",
    onlineDate: "",
    client: "",
    satelite: "",
    file: "",
  };

  if (!uploadExcel.value.emailDate) {
    errors.value.emailDate = "Tanggal email wajib diisi.";
    isValid = false;
  }
  if (!uploadExcel.value.onlineDate) {
    errors.value.onlineDate = "Tanggal online wajib diisi.";
    isValid = false;
  }
  if (!uploadExcel.value.client) {
    errors.value.client = "Silakan pilih pelanggan.";
    isValid = false;
  }
  if (!uploadExcel.value.satelite) {
    errors.value.satelite = "Silakan pilih satelit.";
    isValid = false;
  }
  if (!uploadExcel.value.file) {
    errors.value.file = "Silakan pilih file untuk diupload.";
    isValid = false;
  }

  return isValid;
};

const submit = async () => {
  if (!validate()) {
    return;
  }

  document.getElementById('closeModal1Btn')?.click();

  let link = document.createElement("button");
  link.type = "button";
  link.setAttribute("data-bs-toggle", "modal");
  link.setAttribute("data-bs-target", `#${alert1}`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  const param = uploadExcel.value;
  loadingImport.value = true;
  alertType.value = "loading";
  try {
    const uploadRes = await apiService.uploadPerangkat(
      param.client,
      param.onlineDate,
      param.emailDate,
      param.file,
      param.satelite
    );
    addData.value = uploadRes.data.totalImport;
    duplicateData.value = uploadRes.data.totalDuplikat;
    alertType.value = "success";
    loadingImport.value = false;
    uploadExcel.value = {
      emailDate: "",
      onlineDate: "",
      client: "",
      file: "",
    };
  } catch (error) {
    loadingImport.value = false;
    alertType.value = "error";
    messageRes.value.code = error.response?.status || "Error";
    messageRes.value.text = error.response?.data?.message || error.message;
  }
};

const done = () => {
  router.push({ name: "Duplikasi" });
};

const toDuplikasi = () => {
  router.push({ name: "Duplikasi" });
};

const toRiwayat = () => {
  router.push({ name: "RiwayatUpload" });
};

let timeoutIdMts;
const getDataMts = async (e) => {
  try {
    if (timeoutIdMts) {
      clearTimeout(timeoutIdMts);
    }
    const data = filter.value.mts;
    if (data && data.length > 2 && e.keyCode !== 8) {
      timeoutIdMts = setTimeout(async () => {
        const res = await apiService.getMts(data);
        dataMts.value = res.data;
      }, 500);
    }
  } catch (error) {
    console.log(error);
  }
};

let timeoutIdBatch;
const getDataBatch = async (e) => {
  try {
    if (timeoutIdBatch) {
      clearTimeout(timeoutIdBatch);
    }
    const data = filter.value.batch;
    if (data && data.length > 2 && e.keyCode !== 8) {
      timeoutIdBatch = setTimeout(async () => {
        const res = await apiService.getBatch(data);
        dataBatch.value = res.data;
      }, 500);
    }
  } catch (error) {
    console.log(error);
  }
};

let timeoutIdStation;
const getDataStation = async (e) => {
  try {
    if (timeoutIdStation) {
      clearTimeout(timeoutIdStation);
    }
    const data = filter.value.station;
    if (data && data.length > 2 && e.keyCode !== 8) {
      timeoutIdStation = setTimeout(async () => {
        const res = await apiService.getStation(data);
        dataStation.value = res.data;
      }, 500);
    }
  } catch (error) {
    console.log(error);
  }
};

const dataBatchDownload = ref({});
let timeoutIdBatchDownload;
const getDataBatchDownload = async (e) => {
  try {
    if (timeoutIdBatchDownload) {
      clearTimeout(timeoutIdBatchDownload);
    }
    const data = filterDownload.value.batch;
    if (data && data.length > 2 && e.keyCode !== 8) {
      timeoutIdBatchDownload = setTimeout(async () => {
        const res = await apiService.getBatch(data);
        dataBatchDownload.value = res.data;
      }, 500);
    }
  } catch (error) {
    console.log(error);
  }
};

onUnmounted(() => {
  store.state.selectedBatchUpload = null;
})
</script>

<style scoped>
#fileUploadButtonLabel {
  padding: 0.5rem;
  font-family: sans-serif;
  border-radius: 0.3rem;
  cursor: pointer;
  margin-top: 1rem;
}
</style>
